import script from "./CompleteProfile.vue?vue&type=script&setup=true&lang=js"
export * from "./CompleteProfile.vue?vue&type=script&setup=true&lang=js"

import "./CompleteProfile.vue?vue&type=style&index=0&id=6ae0a3ca&lang=css"

const __exports__ = script;

export default __exports__